import { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import FastfoodOutlinedIcon from "@mui/icons-material/FastfoodOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {  i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  return (
    <MenuItem
      active={selected === title}
      style={{ color: colors.grey[100] }}
      onClick={() => setSelected(title)}
      icon={icon}
      sx={{
        display: "flex",
        flexDirection: isRTL ? "row-reverse" : "row", 
        alignItems: "center",
        justifyContent: isRTL ? "flex-end" : "flex-start", 
        gap: "20px", 
        padding: "10px 15px",
      }}
    >
      <Typography sx={{ fontSize: "14px", whiteSpace: "nowrap", flexGrow: 1, textAlign: isRTL ? "right" : "left" }}>
      {title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  return (
    <Box
      sx={{
        direction: isRTL ? "rtl" : "ltr",
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
  padding: isRTL ? "5px 10px 5px 20px !important" : "5px 10px 5px 20px !important",
},
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* شعار التطبيق وزر القائمة */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box display="flex" justifyContent="space-between" alignItems="center" >
                <Typography variant="h3" color={colors.grey[100]}>
                  {t("admin")}
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {/* عناصر القائمة */}
          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item title={t("dashboard")} to="/" icon={<HomeOutlinedIcon />} selected={selected} setSelected={setSelected} />

            <Typography variant="h6" color={colors.grey[300]} sx={{ m:isRTL?"15px 20px 5px 0px":"15px 0 5px 20px" ,textAlign: isRTL ? "right" : "left" }}>
              {t("data")}
            </Typography>

            <Item title={t("employee")} to="/employee" icon={<PeopleOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("invoices_balances")} to="/invoices" icon={<ReceiptLongOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("expenses_balances")} to="/expenses" icon={<MonetizationOnOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("inventory")} to="/inventory" icon={<Inventory2OutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("daily_consumption")} to="/dailyConsumption" icon={<FastfoodOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("attendance")} to="/attendance" icon={<EventAvailableOutlinedIcon />} selected={selected} setSelected={setSelected} />

            <Typography variant="h6" color={colors.grey[300]} sx={{ m:isRTL?"15px 20px 5px 0px":"15px 0 5px 20px" ,textAlign: isRTL ? "right" : "left" }}>
              {t("pages")}
            </Typography>

            <Item title={t("create_employee")} to="/createEmployee" icon={<PersonAddAltOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("create_sales")} to="/createInvoices" icon={<PointOfSaleOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("create_expenses")} to="/createExpenses" icon={<MonetizationOnOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("create_inventory")} to="/createInventory" icon={<AddBusinessOutlinedIcon />} selected={selected} setSelected={setSelected} />
            <Item title={t("create_daily_consumption")} to="/createDailyConsumption" icon={<FastfoodOutlinedIcon />} selected={selected} setSelected={setSelected} />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
